//lang.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './en.json';
import zhHant from './tw.json';

Vue.use(VueI18n);

const locale = 'zhHant'

const messages = {
    en, zhHant
}

const i18n = new VueI18n({
    locale,
    messages
});

export default i18n;